import { FormArray, FormControl, FormGroup} from '@angular/forms';
import Swal from "sweetalert2";
import {ROUTES} from "@enums";

export class AppBaseComponent {
  clearField = (form: FormGroup, field: string): void => {
    form.get(field).reset()
  }

  isDevelopment = (): boolean => {
    return window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1');
  }

  openBlankPage = (url: string): void => {
    window.open(url, '_blank');
  }

  isTouchedField = (form: FormGroup, field: string): boolean => {
    return form?.get(field).touched === true && form?.get(field).invalid;
  }

  isNotPristinedField = (form: FormGroup, field: string): boolean => {
    return form?.get(field).touched === true
  }

  isValidField = (form: FormGroup, field: string): boolean => {
    return (
      form?.get(field).touched && form?.get(field).valid
    );
  }

  isCorrectField = (form: FormGroup, field: string): boolean => {
    return (
      form?.get(field).valid
    );
  }



  dateValidator(control: FormControl): { [s: string]: boolean } {
    if (control.value) {
      const date = new Date(control.value);
      const today = new Date(Date.now());
      if (date > (today)) {
        return {'invalidDate': true }
      }
    }
    return null;
  }


  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  popUpRegistroNaturalJuridica(router): void {
    Swal.fire({
      title: 'Complete su registro',
      text: "Tenga en cuenta, que para realizar nuestros trámites en linea, es obligatorio diligenciar previamente el REGISTRO DEL CIUDADANO (persona natural o jurídica), el cual servirá para la realización de trámites posteriores ante la Secretaría Distrital de Salud",
      icon: 'info',
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonColor: '#0000FF',
      cancelButtonColor: '#0000FF',
      showCancelButton: true,
      confirmButtonText: 'REGISTRO PERSONA NATURAL',
      cancelButtonText: 'REGISTRO PERSONA JURÍDICA',
    }).then((result) => {
      if (result.isConfirmed) {
        router.navigateByUrl(ROUTES.RegistrationNatural);
      } else {
        router.navigateByUrl(ROUTES.RegistrationLegal);
      }
    })
  }

  popUpAceptarPoliticaDatos(router): void {
    Swal.fire({
      title: 'Complete su registro',
      text: "Tenga en cuenta, que para realizar nuestros trámites en linea, es obligatorio aceptar la política de protección y tratamiento de datos personales, el cual servirá para la realización de trámites posteriores ante la Secretaría Distrital de Salud",
      icon: 'info',
      allowEscapeKey: false,
      allowOutsideClick: false,
      confirmButtonColor: '#0000FF',
      confirmButtonText: 'ACEPTAR',
    }).then((result) => {
      if (result.isConfirmed) {
        router.navigateByUrl(ROUTES.ACEPTAR_POLITICA_DATOS);
      }
    })
  }
}
